// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"540bd904","94":"b4bd03fa","239":"3fec4b50","259":"023b8d3f","345":"9af2c218","394":"93293994","451":"58876849","512":"97629025","525":"a19eb20d","553":"cd6b4343","965":"b94015c9"}[chunkId] + ".chunk.js";
};